import {
  Component,
  Input,
  ViewEncapsulation,
  Output,
  EventEmitter
} from '@angular/core';
import { TrackingPageModel } from '../../tracking-page.model';

@Component({
  selector: 'app-tracking-page-footer',
  templateUrl: './tracking-page-footer.component.html',
  styleUrls: ['./tracking-page-footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TrackingPageFooterComponent {
  @Input() mode: any;
  @Input() noSidebar: boolean;
  @Input() selectedId: any;
  @Input() trackingPage: TrackingPageModel;
  @Input() isVisualBuilder = true;
  @Output() selectItem = new EventEmitter();

  public onAnchorClick(event): void {
    if (this.isVisualBuilder) {
      event.preventDefault();
    }
  }
}
